module.exports = __webpack_public_path__ + "img/play-grey.587fed15.svg";